import React from 'react';
import { useContributionStatus } from '../../hooks/useSubmissions';
import { Card, CardBody } from '../common';

/**
 * GM-only component showing a breakdown of submitted content by type and player
 * Displayed during submission phase so GM can see what's coming in
 */
export const SubmissionBreakdown = ({ gameId, roundId }) => {
  const { data, isLoading } = useContributionStatus(gameId, roundId);

  if (isLoading || !data) {
    return (
      <Card>
        <CardBody>
          <div className="animate-pulse space-y-2">
            <div className="h-5 bg-gray-200 rounded w-1/3"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </CardBody>
      </Card>
    );
  }

  const { breakdown, summary } = data;

  // No breakdown data means either not GM or no submissions yet
  if (!breakdown) {
    return null;
  }

  const formatLabel = (item) => {
    const { type, units, playerName } = item;
    const typeLabel = type === 'text'
      ? `${units} unit${units !== 1 ? 's' : ''} of text`
      : type === 'images'
        ? `${units} image${units !== 1 ? 's' : ''}`
        : `${units} audio clip${units !== 1 ? 's' : ''}`;

    return `${typeLabel} (${playerName})`;
  };

  return (
    <Card>
      <CardBody>
        <h3 className="font-semibold mb-3">Submissions Received</h3>

        {summary.submitted === 0 ? (
          <p className="text-sm text-gray-500 italic">
            No submissions yet. Waiting for players...
          </p>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-gray-600">
              {summary.submitted} of {summary.total} player{summary.total !== 1 ? 's' : ''} submitted
            </p>

            {breakdown.length > 0 && (
              <ul className="space-y-1.5">
                {breakdown.map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm">
                    <span className="text-gray-400 mt-0.5">•</span>
                    <span className="text-gray-700">{formatLabel(item)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </CardBody>
    </Card>
  );
};
